<template>
  <v-card align="center" justify="center" light min-width="49vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="closeWindow">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-2 pt-7 pb-10">
      <p class="text-center" v-html="$t('explanation')"/>
      <p v-if="paused">
        {{ $t('paused.prepend') }} <v-icon class="mx-1 mt-n1" color="#c88600" small>fa-circle</v-icon> {{ $t('paused.append') }}
        <a :href="faqsUrl" target="_blank">{{ $t('paused.link') }}</a>
      </p>
      <apexchart :options="distributionOptions" :series="distributionSeries" height=350 type=bar />
        <v-btn @click="closeWindow">{{ $t('btnClose') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/journal';

export default {
  name: "TradesDistribution",
  props: {
    paused: Boolean,
    fromDate: Date,
    toDate: Date,
    brokerAccount: Number,
    faqsUrl: String,
  },
  data() {
    return {
      trades: [],
      distributionSeries: [],
      distributionOptions: {},
    };
  },
  mounted() {
    this.getTrades();
  },
  watch: {
    trades() {
      this.computeData();
    }
  },
  methods: {
    getTrades() {
      let filter = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        side: 'All',
        mood: 'All',
        asset: 'All',
        brokerAccount: this.brokerAccount,
        result: 'All',
      };

      Repository.filteredTradesOfUserGet(filter).then((response) => {
        if (response.status < 400) {
          this.trades = response.data.content;
        }
      });
    },
    computeData() {
      this.distributionSeries = [];
      let numberOfTrades = 0;
      let maxContributionLimit = 0;
      let profits = [];
      let datesRR = [];

      this.trades.forEach((trade) => {
        profits.push(trade.netProfit);
        if (trade.netProfit > 0)
          maxContributionLimit += trade.netProfit;
        numberOfTrades++;
        datesRR.push(numberOfTrades);
      });

      maxContributionLimit *= 0.3;

      this.distributionSeries = [
        {name: 'Profit', data: profits,},
      ];

      this.distributionOptions = {
        noData: {
          text: 'No data for the current filter',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: '#111111',
            fontSize: '21px',
            fontFamily: 'Ubuntu, sans-serif',
          }
        },
        chart: {
          //stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            colors: {
              ranges: [
                {
                  from: 0,
                  to: maxContributionLimit,
                  color: '#247851'
                },
                {
                  from: maxContributionLimit + 0.1,
                  to: 200000000,
                  color: '#c88600'
                },
                {
                  from: -200000000,
                  to: 0,
                  color: '#FF4747'
                }]
            },
            columnWidth: '80%',
          }
        },
        dataLabels: {
          enabled: false
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return `$${value.toFixed(2)}`;
            },
            style: {
              color: '#6C7079',
            },
          },
        },
        xaxis: {
          categories: datesRR,
        },
        tooltip: {
          x: {
            formatter: function (value) {
              return ((value * 1) > 3) ? `${value.toFixed(0)}th trade` :
                  ((value * 1) === 1) ? `${value.toFixed(0)}st trade` :
                      ((value * 1) === 2) ? `${value.toFixed(0)}nd trade` : `${value.toFixed(0)}rd trade`;
            }
          }
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      };

      this.distributionOptions.annotations = {
        yaxis: [{
          y: maxContributionLimit,
          borderColor: '#111111',
          label: {
            show: true,
            text: 'Contribution Limit',
            borderWith: 5,
            style: {
              color: "#FFFFFF",
              background: '#111111'
            }
          }
        }]
      };
    },
    closeWindow() {
      this.$emit('closeWindow');
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Trades Distribution",
    "explanation": "Contribution Limit is <b>30% of the sum</b> of your winning trades.",
    "paused": {
      "prepend": "You are not qualifying, because the profit of",
      "append": "trade(s) is(are) higher than the contribution limit |",
      "link": "See rule here."
    },
    "btnClose": "Ok, Close"
  },
  "es": {
    "title": "Distribución de Trades",
    "explanation": "El límite de contribución es el <b>30% de la suma</b> de tus trades ganadores.",
    "paused": {
      "prepend": "No estas en el ranking, porque el beneficio del",
      "append": "trade(s) es(son) más grandes que el límite de contribución |",
      "link": "Mira las reglas aquí."
    },
    "btnClose": "Entendido, Cerrar"
  }
}
</i18n>

<style scoped>

</style>
